import { useContext } from 'react'
import { LocaleContext } from 'components/common/LocaleContext'
import { formatPriceWithCurrency } from 'utils/formatPriceWithCurrency'
export const usePriceFormat = () => {
  const { dateStringLocale } = useContext(LocaleContext)
  return {
    formatPriceDefault: (amount: number, currency: string, quantity = 1) =>
      formatPriceWithCurrency(amount, currency, dateStringLocale, quantity),
    formatSymbol: (currency: string) => {
      return new Intl.NumberFormat(dateStringLocale, {
        currency,
        currencyDisplay: 'symbol',
        maximumFractionDigits: 0,
        style: 'currency'
      })
        .format(0)
        .replace('0', '')
        .trim()
    }
  }
}
